"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuAstral = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var PrevisuAstral = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(PrevisuAstral, _React$Component);

  function PrevisuAstral(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = PrevisuAstral.prototype;

  _proto.render = function render() {
    var baguetteStyle1 = {
      maxWidth: "100%",
      maxHeight: "70%",
      marginBottom: "30px",
      boxShadow: "5px 5px 6px #cac9c9"
    };
    var baguetteStyle4 = {
      maxWidth: "30%",
      maxHeight: "100%",
      marginBottom: "30px",
      boxShadow: "5px 5px 6px #cac9c9"
    };
    var ImgSelect = 2;

    if (this.props.largeur === this.props.hauteur) {
      ImgSelect = 2;
    } else if (this.props.largeur < this.props.hauteur) {
      ImgSelect = 4;
    } else if (this.props.largeur > this.props.hauteur) {
      ImgSelect = 3;
    }

    var Image = props.imageComponent;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "300px",
        backgroundColor: "white",
        padding: "20px"
      }
    }, ImgSelect === 2 ? /*#__PURE__*/_react.default.createElement(Image, {
      image: this.props.img.img2,
      alt: "photo cadre astral"
    }) : "", ImgSelect === 3 ? /*#__PURE__*/_react.default.createElement(Image, {
      image: this.props.img.img3,
      alt: "photo cadre astral",
      style: baguetteStyle1
    }) : "", ImgSelect === 4 ? /*#__PURE__*/_react.default.createElement(Image, {
      image: this.props.img.img4,
      alt: "photo cadre astral",
      style: baguetteStyle4
    }) : ""));
  };

  return PrevisuAstral;
}(_react.default.Component);

exports.PrevisuAstral = PrevisuAstral;
PrevisuAstral.propTypes = {
  largeur: _propTypes.default.number,
  hauteur: _propTypes.default.number,
  img: _propTypes.default.object,
  imageComponent: _propTypes.default.element
};
var _default = PrevisuAstral;
exports.default = _default;